// src/services/UnmappedService.js
//
// Badges that have opened a door but belong to nobody Vero knows.

import apiClient from './apiClient'

export async function getUnmappedBadges() {
  const response = await apiClient.post('/GetUnmappedBadges', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read unmapped badges')
  }
  return response.data.badges ?? []
}
